var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoyful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.8 81.3",
    style: {
      enableBackground: "new 0 0 95.8 81.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 42.9,
    cy: 12.1,
    r: 12.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9,38.9c0,0-14.1-17.1-47.9-21c0,0,47.8,17.8,48.1,63.4h0.1c1.2-5.5,14.3-64.5,47.6-80.7C95.8,0.6,63.5,7.4,47.9,38.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoyful);
export default __webpack_public_path__ + "static/media/joyful.a19a3c89730d141390bb7ff04a3a3389.svg";
export { ForwardRef as ReactComponent };